module.exports = __webpack_public_path__ + "img/info_circle.005cacce.svg";